import { CURSOR_STYLE, REGION_STYLES, ZOOM_MODE } from './config';

export class CanvasDrawer {
    #canvas;
    #ctx;
    #videoContainer;

    constructor(canvas, videoContainer) {
        this.#canvas = canvas;
        this.#videoContainer = videoContainer;
    }

    configure() {
        const { width, height } = this.#videoContainer.getBoundingClientRect();
        this.#canvas.width = width;
        this.#canvas.height = height;
        this.#ctx = this.#canvas.getContext('2d');
    }

    isInitialized() {
        return this.#ctx !== null && this.#ctx !== undefined;
    }

    getDimensions() {
        return {
            width: this.#canvas.width,
            height: this.#canvas.height,
        };
    }

    setCursor(cursorStyle) {
        this.#canvas.style.cursor = cursorStyle;
    }

    #applyStyle(zoomMode) {
        const style = zoomMode || ZOOM_MODE.ZOOM_IN;
        this.#ctx.fillStyle = REGION_STYLES[style].fillColor;
        this.#ctx.strokeStyle = REGION_STYLES[style].lineColor;
        this.#ctx.lineWidth = REGION_STYLES[style].lineWidth;

        let cursorStyle;
        if (zoomMode) {
            cursorStyle = style === ZOOM_MODE.ZOOM_IN ? CURSOR_STYLE.ZOOM_IN : CURSOR_STYLE.ZOOM_OUT;
        } else {
            cursorStyle = CURSOR_STYLE.DEFAULT;
        }
        this.setCursor(cursorStyle);
    }

    getZoomMode(rectWidth) {
        if (!rectWidth) return null;
        return rectWidth > 0 ? ZOOM_MODE.ZOOM_IN : ZOOM_MODE.ZOOM_OUT;
    }

    drawRect(startPoint, endPoint) {
        if (!this.#ctx) return;

        this.clear();

        if (!startPoint || !endPoint) return;

        const width = endPoint.x - startPoint.x;
        const height = endPoint.y - startPoint.y;
        const zoomMode = this.getZoomMode(width);

        this.#applyStyle(zoomMode);

        this.#ctx.strokeRect(startPoint.x, startPoint.y, width, height);
        this.#ctx.fillRect(startPoint.x, startPoint.y, width, height);
    }

    clear() {
        if (!this.#ctx) return;
        const { width, height } = this.getDimensions();
        this.#ctx.clearRect(0, 0, width, height);
    }

    setDefaultStyle() {
        if (this.#ctx) {
            this.#applyStyle(null);
        }
    }
}
